import { useState, useRef, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { InputText } from "primereact/inputtext";
import dbservice from "../../Utility/DbConnection/dbservice";
import { Toast } from "primereact/toast";

function ProfileDialog({
  visible,
  onHide,
  onLoad,
  selectedMeasures,
  profileType,
}) {
  const [name, setName] = useState("");
  const [groupedMeasures, setGroupedMeasures] = useState({});
  const { t } = useTranslation();

  const toast = useRef(null);

  useEffect(() => {
    if (visible) {
      console.log("ProfileDialog is visible");
      console.log("Selected Measures:", selectedMeasures);
    }
  }, [visible]);
  const SaveProfile = async (profileName) => {
    if (profileName.trim() === "") {
      toast.current.show({
        severity: "error",
        summary: t("error"),
        detail: t("profileNameRequired"),
      });
      return;
    }

    // Group selected measures by machine
    const measuresByMachine = [];
    selectedMeasures.forEach((measure) => {
      if (measure.id && measure.name && measure.machine) {

        measuresByMachine.push({
          SelectedMeasureId: measure.id,
          SelectedMeasureName: measure.name,
          Machine: measure.machine,
        });
      }
    });

    const profileData = {
      ProfileName: profileName,
      Username: "XXXXX",
      ProfileDetails: measuresByMachine,
      ProfileType: profileType, // Assuming 1 = "Search"
    };
    console.log("Profile Data:", profileData);

    dbservice.SendPostRequest(
      `Automata/SaveProfile`,
      JSON.stringify(profileData),
      (response) => {
        console.log("Response:", response);
        if (response.success) {
          toast.current.show({
            severity: "success",
            summary: t("success"),
            detail: t("profileSaved", { profileName }),
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: t("error"),
            detail: response.error,
          });
        }
      },
      (error) => {
        console.error("Error saving profile:", error);
        toast.current.show({
          severity: "error",
          summary: t("error"),
          detail: error,
        });
      },
      toast.current,
      5000
    );
  };

  return (
    <Dialog visible={visible} onHide={onHide} header={t("saveProfile")} style={{width: "20vw", minHeight: "20vh"}} modal>
      <Toast ref={toast} />
      <div>
        <label htmlFor="profileName">{t("profileName")}</label>
        <InputText
          id="profileName"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ width: "100%" }}
        />{" "}
      </div>
      <Button
      icon="pi pi-save"
        label={t("save")}
        onClick={() => {
          if (name.trim() !== "") {
            SaveProfile(name);
          }
        }}
        style={{ marginTop: "2rem", width: "10rem" }}
      />
    </Dialog>
  );
}
export default ProfileDialog;
